import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { BoatOwner } from 'anchor-shared/lib/model/entity/boatOwner';
import { UserSearchResult } from 'anchor-shared/lib/model/interface/userSearchResult';

@Injectable()
export class BoatOwnerDAO extends BaseDAO<BoatOwner> {
  static PATHS = {
    ADD_TO_USER: '/add-new-boat-owner-to-user',
    UPDATE_USER_OWNER: '/updateUserBoatOwner',
    SEND_REQUEST: 'send-owner-request',
    APPROVED: '/approved',
    SEND_APPROVAL_EMAIL: '/send-approval-email',
    GRID_BOATOWNER_USERS: '/grid/boat-owner-users',
  };

  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.BOATOWNER);
  }

  public createBoatOwner(data: any): Observable<BoatOwner> {
    const url: string = this.apiHelper.getServiceName() + this.getResource();
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    const httpRequest: Observable<BoatOwner> =
      this.apiHelper.apiCall<BoatOwner>(url, method, null, data, headers);

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (owner: BoatOwner) => {
          observer.next(owner);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public sendBoatOwnerRequest(data: any): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      BoatOwnerDAO.PATHS.SEND_REQUEST;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    const httpRequest: Observable<any> = this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      data,
      headers,
    );

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (res: any) => {
          observer.next(res);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public loadApprovedOwners(): Observable<BoatOwner[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      BoatOwnerDAO.PATHS.APPROVED;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<BoatOwner[]>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public addBoatOwnerToUser(): Observable<BoatOwner> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      BoatOwnerDAO.PATHS.ADD_TO_USER;
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    const httpRequest: Observable<BoatOwner> =
      this.apiHelper.apiCall<BoatOwner>(url, method, null, null, headers);

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (owner: BoatOwner) => {
          observer.next(owner);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public addNewBoatOwnerToExistingUser(userId): Observable<BoatOwner> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      BoatOwnerDAO.PATHS.ADD_TO_USER +
      '/' +
      userId;
    let method = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    let httpRequest: Observable<BoatOwner> = this.apiHelper.apiCall<BoatOwner>(
      url,
      method,
      null,
      null,
      headers,
    );

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (boatOwner: BoatOwner) => {
          observer.next(boatOwner);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public loadBoatOwnerUsersGrid(): Observable<BoatOwner[]> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      BoatOwnerDAO.PATHS.GRID_BOATOWNER_USERS;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    const httpRequest: Observable<BoatOwner[]> = this.apiHelper.apiCall<
      BoatOwner[]
    >(url, method, null, null, headers);

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (owners: BoatOwner[]) => {
          observer.next(owners);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public updateUserBoatOwner(boatOwner: BoatOwner): Observable<BoatOwner> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      BoatOwnerDAO.PATHS.UPDATE_USER_OWNER;
    let method: string = 'PUT';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    let ownerData: Object = boatOwner;

    let httpRequest: Observable<BoatOwner> = this.apiHelper.apiCall<BoatOwner>(
      url,
      method,
      null,
      ownerData,
      headers,
    );

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (owner: BoatOwner) => {
          observer.next(owner);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public sendApprovalEmail(ownerId: number): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/' +
      ownerId +
      BoatOwnerDAO.PATHS.SEND_APPROVAL_EMAIL;
    let method: string = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    // let captainData = this.getDataFromEntity(captain);
    let httpRequest: Observable<BoatOwner> = this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      null,
      headers,
    );

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (res: any) => {
          observer.next(res);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public adminUpdateBoatOwner(boatOwner: BoatOwner): Observable<BoatOwner> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/' + boatOwner.id;
    let method: string = 'PUT';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    let data: Object = boatOwner;

    let httpRequest: Observable<BoatOwner> = this.apiHelper.apiCall<BoatOwner>(
      url,
      method,
      null,
      data,
      headers,
      null,
    );

    return Observable.create((observer) => {
      httpRequest.subscribe(
        (_data: BoatOwner) => {
          observer.next(_data);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        },
      );
    });
  }

  public adminBoatOwnerSearch(
    searchText: string,
  ): Observable<UserSearchResult[]> {
    const url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/admin/search';
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      searchText: searchText,
    };
    return this.apiHelper.apiCall<UserSearchResult[]>(
      url,
      method,
      null,
      data,
      headers,
    );
  }
}
